export enum InvestigationApprovalMode {
	RaiseToDirector = "raise-to-director",
	RaiseToMinister = "raise-to-minister",
	ExecuteByDirector = "execute-by-director",
	ApproveByMinister = "approve-by-minister",
	SubmitReport = "submit-report",
}
